"use client";

import { useContext } from "react";
import Link from "next/link";
import { useTranslation } from "~/app/hooks/useTranslation";
import useLocalizedHref from "~/app/hooks/useLocalizedHref";
import { HelpCenterContext } from "../context";
import { filterFaqs } from "../search";
import FAQCollapse from "./FAQCollapse";
import FaqSchema from "./FaqSchema";
import styles from "../[slug]/page.module.scss";

export default function SearchResults({ children }) {
  const { faqContent, faqSections, searchState } = useContext(HelpCenterContext);
  const { t } = useTranslation();
  const { locale, buildHref } = useLocalizedHref();
  if (!searchState.value.trim()) return children;

  const groups = Object.entries(faqContent)
    .map(([slug, faqs]) => ({ slug, faqs: filterFaqs(faqs, searchState.value, locale) }))
    .filter(({ faqs }) => faqs.length);

  return (
    <section className={styles.container} aria-label={t("helpCenter.searchSection.searchLabel")}>
      <FaqSchema items={groups.flatMap(group => group.faqs)}/>
      <div role="status">{!groups.length && <h2>{t("helpCenter.noFAQs")}</h2>}</div>
      {groups.map(({ slug, faqs }) => (
        <section key={slug}>
          <h2><Link href={buildHref(`help-center/${slug}`)}>{t(faqSections[slug])}</Link></h2>
          {faqs.map((faq) => (
            <FAQCollapse key={faq.question} title={faq.question} headingLevel="h3">
              <div className={styles.faqContent}>{faq.answer}</div>
            </FAQCollapse>
          ))}
        </section>
      ))}
    </section>
  );
}
